module.exports = __webpack_public_path__ + "img/lead-detail-activity.ec62fef0.png";